import {createFileRoute} from '@tanstack/react-router';
import {DepositApplicationAddFundsPage} from 'features/deposit/onboarding/pages/DepositApplicationAddFundsPage';

export const Route = createFileRoute(
  '/_protected/deposit-onboarding/$applicationId/$productCode/add-funds',
)({
  component: DepositApplicationAddFundsPage,
  validateSearch: (search) => {
    return {
      accountId: search.accountId as string | undefined,
    };
  },
});
